import { accountsPost } from "./api";
import { isUndefinedOrNull } from "./type_guards";

export async function checkTOSMismatch(orgId, userId) {
  try {
    const url = `accounts/checkTOSMismatch`;
    const body = {
      orgId,
      userId,
    };

    const mismatchExists = await accountsPost(url, body);

    if (!isUndefinedOrNull(mismatchExists.checkTOSMismatch)) {
      return mismatchExists.checkTOSMismatch;
    }
    return false;
  } catch (error) {
    console.error("Error checking TOS mismatch", error);
    return false;
  }
}
